import React from 'react';
import { Link } from 'react-router-dom';
import PrimaryButton from './Buttons/PrimaryButton';

const SetButtonsDashBoard = ({ children }) => {
    return (
        <div
            className="flex flex-nowrap w-[100vw] md:w-auto overflow-x-scroll no-scrollbar items-center justify-start flex-row gap-2 mb-4 divide-x divide-slate-600 pr-8"
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            {children}
        </div>
    );
};

export default SetButtonsDashBoard;
